import React, { useContext, useEffect } from 'react';
import clsx from 'clsx';
import GDPRContext from '../../../services/GDPRContext';
import alertsStyle from '../../../edcom-ui/styles/alerts.module.less';
import gdprBannerStyle from './GDPRBanner.module.less';
import { Button } from 'edcom-ui';
import { gdprOptIn } from './api';

export default function GDPRBanner() {
  const { inGdpr, refreshGDPRContext } = useContext(GDPRContext);

  useEffect(() => {}, [GDPRContext]);

  const getGDPRCookieValue = () => {
    let gdprCookie = '';
    if (typeof document === 'undefined') return gdprCookie;

    const cookie = document.cookie;
    if (!cookie) return gdprCookie;

    const cookieArray = cookie.split('; ');
    cookieArray.forEach(cookieString => {
      const c = cookieString.split('=');
      if (c[0] !== 'gdpr') return;
      gdprCookie = c[1];
    });

    return gdprCookie;
  };

  async function optIn() {
    const response = await gdprOptIn();

    if (response.status) {
      // Call the callback ... this will clear the cache and reload the context.
      refreshGDPRContext();
    }
  }

  if (!inGdpr || getGDPRCookieValue() === '1') return null;

  return (
    <div
      className={clsx(
        gdprBannerStyle.banner,
        alertsStyle.alert,
        alertsStyle.banner,
        alertsStyle['alert-notice']
      )}
    >
      <span className={gdprBannerStyle.description}>
        We enable strictly necessary cookies to give you the best possible
        experience on Education.com.
      </span>
      <a
        href="/cookie-policy/"
        className={gdprBannerStyle.link}
        target="_blank"
      >
        Cookie Policy
      </a>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <Button
        className={gdprBannerStyle.button}
        color="secondary"
        title={'Enable Performance Cookies'}
        onClick={optIn}
      >
        Enable Performance Cookies
      </Button>
    </div>
  );
}
